// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-card[data-v-7091d7d8]{margin-top:0;margin-bottom:0}", ""]);
// Exports
module.exports = exports;
